export const Risk = {
  RAIN: {
    index: 1,
    key: "rain",
    string: "予測降雨",
    title: "予測降雨",
    icon: "mdi-weather-pouring",
    slider: true,
    subControl: true,
    isShowMobile: true
  },
  OBSERVATORY: {
    index: 2,
    key: "observatory",
    string: "観測所",
    title: "観測所",
    icon: "mdi-office-building-marker",
    subControl: true,
    isShowMobile: false
  },
  RIVER_FLOODING: {
    index: 3,
    key: "riverFlooding",
    string: "内水リスク",
    title: "内水リスク",
    icon: "mdi-waves",
    slider: true,
    subControl: true,
    isShowMobile: true
  },
  WIND: {
    index: 4,
    key: "wind",
    string: "風",
    title: "風",
    icon: "mdi-weather-windy",
    slider: true,
    subControl: true,
    isShowMobile: false
  },
  SNOW: {
    index: 5,
    key: "snow",
    string: "予測積雪深",
    title: "予測積雪深",
    icon: "mdi-weather-snowy-heavy",
    slider: true,
    subControl: true,
    isShowMobile: false
  },
  DOSYA: {
    index: 6,
    key: "dosya",
    string: "土砂キキクル",
    title: "土砂キキクル",
    icon: "mdi-elevation-decline",
    slider: true,
    subControl: true,
    isShowMobile: false
  },
  KOUZUI: {
    index: 7,
    key: "kouzui",
    string: "洪水キキクル",
    title: "洪水キキクル",
    icon: "mdi-home-flood",
    slider: true,
    subControl: false,
    isShowMobile: false
  },
  TYPHOON: {
    index: 8,
    key: "typhoon",
    string: "台風情報",
    title: "台風情報",
    icon: "mdi-weather-hurricane",
    slider: false,
    subControl: false,
    isShowMobile: true,
    url:
      "https://www.jma.go.jp/bosai/map.html#5/34.5/137/&elem=root&typhoon=all&contents=typhoon"
  },
  DISASTER_PREVENTION: {
    index: 9,
    key: "disasterPrevention",
    string: "川の防災情報",
    title: "川の防災情報",
    icon: "mdi-information",
    slider: false,
    subControl: false,
    isShowMobile: true,
    url: "https://www.river.go.jp/portal/?region=1301107&contents=multi"
  }
};
